import React from 'react';
import '../styles/Apartments.css';    

const Parking: React.FC = () => {

  return (
    <div className="location-container">
      <div className="location-content">
        <div className="location-image" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <img 
            src={`${process.env.PUBLIC_URL}/images/Aaron%20Glen%20Parking.drawio.png`} 
            alt="Parking area at Aaron Glen" 
            width="754" 
            style={{ display: 'block', margin: '0 auto' }}
        />
        </div>
      </div>
    </div>
  );
};

export default Parking;
